const formatQuantity = value => Number(Number(value).toFixed(2))

export default formatQuantity
